module.exports = __webpack_public_path__ + "img/LOGO_NOVO_aprovado_transp.26833601.png";